/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  designations: '',
  reportPhotos: '',
  deleteReport: '',
};

const reportphotoReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'DESIGNATION':
      return { ...state, designations: action.response };
    case 'DELETE_REPORT':
      return { ...state, deleteReport: action.response };
    case 'DESIGNATION2':
      return { ...state };
    case 'PRESIGNEDURL':
      return {
        ...state,
        preSignedUrl: action.response,
      };
    default:
      return state;
  }
};

export default reportphotoReducer;
